import React from 'react';
import { Box, SpacingStack, TextV2 } from '@withjoy/joykit';
import { MissingGift } from '@withjoy/joykit/icons';
import { useTranslation } from '@shared/core/i18n';
import { useCheckoutFunnel } from '../../hooks';
import { LayoutShell, PrimaryCta } from '../../components';
import { RegistryItemNotFoundSelectors } from './RegistryItemNotFound.selectors';

export const RegistryItemNotFound = () => {
  const { closeDialog } = useCheckoutFunnel(({ closeDialog }) => [closeDialog]);
  const { tq } = useTranslation('guestRegistry');

  return (
    <LayoutShell {...RegistryItemNotFoundSelectors.ContainerElement}>
      <LayoutShell.Body>
        <LayoutShell.SingleColumnPanel>
          <Box paddingBottom={5}>
            <MissingGift size="xxl" />
          </Box>
          <SpacingStack spacing={7}>
            <SpacingStack
              spacing={5}
              alignItems="center"
            >
              <TextV2
                typographyVariant="display2"
                textAlign="center"
              >
                {tq`This gift isn't available`}
              </TextV2>
              <TextV2
                typographyVariant="body1"
                textAlign="center"
              >
                {tq`We couldn't load this gift. It may have been removed from the registry, or the connection dropped. Please close this window and try again.`}
              </TextV2>
            </SpacingStack>
            <PrimaryCta
              {...RegistryItemNotFoundSelectors.CloseButton}
              onClick={closeDialog}
            >
              {tq`Close`}
            </PrimaryCta>
          </SpacingStack>
        </LayoutShell.SingleColumnPanel>
      </LayoutShell.Body>
    </LayoutShell>
  );
};
